module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "gwi-profile"
    }
  }, [_c('div', {
    staticClass: "main mybgcolor",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "mylogin arr-row click-toPerson",
    on: {
      "click": _vm.goPersonal
    }
  }, [_c('div', {
    staticClass: "myphoto"
  }), _vm._v(" "), _c('div', {
    staticClass: "mymessage"
  }, [_c('p', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.nickName))]), _vm._v(" "), _c('p', {
    staticClass: "phoneno"
  }, [_vm._v("手机号： " + _vm._s(_vm._f("dotted")(_vm.user.mobileNo)))])])])]), _vm._v(" "), _c('scroll', {
    staticClass: "to-profile",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "profile-btn-addVoucher",
      "type": "button",
      "disabled": 3 == _vm.voucherList.length
    },
    on: {
      "click": _vm.goAddVoucher
    }
  }, [_vm._v("\n        办卡/绑卡\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "f-minor text-center mytips"
  }, [(3 == _vm.voucherList.length) ? _c('span', {
    attrs: {
      "id": "profile-span-full"
    }
  }, [_vm._v("就诊凭证已满，如需绑定请先解绑其他就诊凭证")]) : (0 == _vm.voucherList.length) ? _c('span', {
    attrs: {
      "id": "profile-span-empty"
    }
  }, [_vm._v("请绑定就诊凭证")]) : _c('span', {
    attrs: {
      "id": "profile-span-normal"
    }
  }, [_vm._v("还能绑定"), _c('span', {
    staticClass: "mygray",
    attrs: {
      "id": "profile-span-surplus"
    }
  }, [_vm._v(_vm._s(3 - _vm.voucherList.length))]), _vm._v("张就诊凭证")])])]), _vm._v(" "), _vm._l((_vm.voucherList), function(voucher, index) {
    return _c('div', {
      key: index,
      staticClass: "voucher-list",
      class: 0 == index ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.selectVoucher(voucher, index, $event)
        }
      }
    }, [_c('health-card', {
      attrs: {
        "id": 'profile-voucherItem-' + voucher.cardNo,
        "data": voucher,
        "edit": 0,
        "is-frequent": index === 0
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b65c06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profile/Profile.vue
// module id = 825
// module chunks = 0